import { Typography } from "@mui/material";
import Loader from "components/Loader";
import useAuth from "../../hooks/useAuth";
import AuthWrapper from "../../sections/auth/AuthWrapper";
import AuthLogin from "../../sections/auth/auth-forms/AuthLogin";
import logoDark from "../../assets/images/logo-dark.svg";
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { setLoggingInStatus, setLogin } from "store/reducers/login";
import { dispatch } from "store"
const Login = () => {
  const { isLoggingIn, isLoggingOut, isLoggedIn, login } = useAuth()
  const { loginWithRedirect, isAuthenticated, getAccessTokenSilently, user, error} = useAuth0();

  useEffect(() => {
    // const login = async () => {
    //   try {
    //     console.log("Trying to Log In ===>")
    //     dispatch(setLoggingInStatus({ isLoggingIn: true }));
    //     await loginWithRedirect({ 
    //       appState: {
    //         returnTo: window.location.pathname
    //       }
    //     });
    //     const isLoggedIn = isAuthenticated;
    //     console.log("LoggedIn Successful ===>", isLoggedIn)
    //     console.log("User ===>", user)
    //     console.log("Error After LogIn ===>", error)
    //     if (isLoggedIn) {
    //       const token = await getAccessTokenSilently();
    //       const newState = {
    //         isLoggedIn: true,
    //         token,
    //         user: {
    //           id: user?.sub,
    //           avatar: user?.picture,
    //           email: user?.email,
    //           name: user?.name,
    //           tier: "Premium",
    //         },
    //       };
    //       dispatch(setLogin(newState));
    //       dispatch(setLoggingInStatus({ isLoggingIn: false }));
    //     } else {
    //       dispatch(setLoggingInStatus({ isLoggingIn: false }));
    //     }
    //   } catch (error) {
    //     console.log("error", error);
    //     dispatch(setLoggingInStatus({ isLoggingIn: false }));
    //   }
    // };
   
    if (!isAuthenticated && !isLoggingIn && !isLoggingOut) {
      login()
    }
    console.log("isAuthenticated =======>", isAuthenticated)
    console.log("isLoggedIn =======>", isLoggedIn)

  },[])
  

 
  return <Loader />
  // return (
  //   <AuthWrapper>
  //     <div className="brand-logo">
  //       <img src={logoDark} className="img-fluid dark-logo" alt="" />
  //     </div>
  //     <div className="login-info">
  //       <Typography variant="h1">Welcome back,</Typography>
  //       <Typography variant="body1">where dreams become a reality.</Typography>
  //       <AuthLogin isDemo={isLoggedIn} />
  //       <Typography className="bottom-content" variant="body1">
  //         Your platform <span>for prosperity</span>
  //       </Typography>
  //     </div>
  //   </AuthWrapper>
  // );
};

export default Login;
